// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';

export class ContactSummary {
  readonly id: string;
  readonly firstName: string;
  readonly lastName: string;
  readonly emailAddress: string | null;
  readonly phoneNumber: string | null;
  readonly companyId: string;
  readonly companyName: string;
  readonly jobTitle: string | null;
  readonly isArchived: boolean;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.firstName = data.firstName === undefined ? '' : data.firstName;
    this.lastName = data.lastName === undefined ? '' : data.lastName;
    this.emailAddress = data.emailAddress === undefined ? null : data.emailAddress;
    this.phoneNumber = data.phoneNumber === undefined ? null : data.phoneNumber;
    this.companyId = data.companyId === undefined ? NIL_UUID : data.companyId;
    this.companyName = data.companyName === undefined ? '' : data.companyName;
    this.jobTitle = data.jobTitle === undefined ? null : data.jobTitle;
    this.isArchived = data.isArchived === undefined ? false : data.isArchived;
  }

  static zero(): ContactSummary {
    const zeroValues: ExcludeMethodsDeep<ContactSummary> = {
      id: NIL_UUID,
      firstName: '',
      lastName: '',
      emailAddress: null,
      phoneNumber: null,
      companyId: NIL_UUID,
      companyName: '',
      jobTitle: null,
      isArchived: false,
    };
    return new ContactSummary(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  fullName(): string {
    return `${this.firstName} ${this.lastName}`;
  }

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type ContactSummaryWireFormat = {
  id: string;
  firstName: string;
  lastName: string;
  emailAddress: string | null;
  phoneNumber: string | null;
  companyId: string;
  companyName: string;
  jobTitle: string | null;
  isArchived: boolean;
};

type NewContactSummaryProps = PartialDeep<ContactSummary, { recurseIntoArrays: true }>;
export const NewContactSummary: (props: NewContactSummaryProps) => ContactSummary = (props) =>
  new ContactSummary(props);

type NewContactSummaryFromWireFormatProps = PartialDeep<
  ContactSummaryWireFormat,
  { recurseIntoArrays: true }
>;
export const NewContactSummaryFromWireFormat: (
  props: NewContactSummaryFromWireFormatProps,
) => ContactSummary = (props) => new ContactSummary(props);
